import {Component} from '@angular/core';
import {TimeoutService} from './timeout.service';


export class TimeoutComponent {
  isVisible = true;

  constructor(private timeoutService: TimeoutService) {
    this.timeoutService.timeoutObservable.subscribe((val: boolean) => this.isVisible = val);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sh-timeout',
  template: `
    <div *ngIf="isVisible">
      <div class="timeout-overlay fullscreen" (click)="isVisible = false"></div>
      <div class="timeout-container" #ref>
        <ng-content>
        </ng-content>
      </div>
      <div *ngIf="ref.children.length == 0" class="timeout-default-box timeout-container">
        <h2>Application will timeout soon.</h2>
      </div>
    </div>
  `,
  styles: [`
    .timeout-default-box {
      text-align: center;
      height: 250px;
      width: 250px;
      background-color: antiquewhite;
      border-radius: 5px;
      padding: 3px;
    }

    .timeout-default-box h2{
      margin-top: 50px;
      overflow-wrap: break-word;
    }
    
    .fullscreen {
      position: fixed;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
    }

    .timeout-overlay {
      z-index: 100;
      background: rgba(0, 0, 0, .2);
    }

    .timeout-container {
      position: fixed;
      z-index: 101;
      left: 50%;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
  `]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TimeoutService, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
